<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    const _t = this
    const timer = setInterval(() => {
      if (_t.$store.getters.token) {
        _t.robot()
      }
    }, 5000)
    _t.$once('hook:beforeDestroy', () => {            
      clearInterval(timer)
    })
  },
  methods: {
    robot() {
      this.$store.dispatch('work/loadDash')
    }
  }

}
</script>
<style lang="scss">
.ds {
  .el-input.is-disabled .el-input__inner {
    color: #606266;
  }
}
</style>
